import { default as Rating1 } from "./level1.png";
import { default as Rating2 } from "./level2.png";
import { default as Rating3 } from "./level3.png";
import { default as Rating4 } from "./level4.png";
import { default as Rating5 } from "./level5.png";

export default [Rating1, Rating2, Rating3, Rating4, Rating5];



// WEBPACK FOOTER //
// ./src/assets/icons/index.js